import React from "react";
import { ArrowUpRight, Search, PenTool, Film, Send } from "lucide-react";
import { SectionLabel, SectionHeading } from "./SectionLabel";

const steps = [
  {
    icon: Search,
    n: "01",
    title: "Discover",
    desc: "We learn about the brand, audience, goals, and current online presence — so every decision is grounded in real context.",
  },
  {
    icon: PenTool,
    n: "02",
    title: "Plan",
    desc: "We create a content direction, visual style, and strategy that gives the brand a clear path forward online.",
  },
  {
    icon: Film,
    n: "03",
    title: "Create",
    desc: "We produce content, visuals, captions, edits, and branded material designed to look and perform like a premium brand.",
  },
  {
    icon: Send,
    n: "04",
    title: "Deliver",
    desc: "We launch, refine, and help the brand build a stronger digital presence — adjusting as we learn what's working.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 border-t border-[rgba(198,162,99,0.12)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <SectionLabel number="03" label="Process" />
            <SectionHeading className="mt-6">
              Our{" "}
              <span className="italic text-gold-metal">process</span>.
            </SectionHeading>
          </div>
          <p className="lg:col-span-5 text-[rgb(var(--bone-dim))] leading-relaxed">
            A clear, four-step workflow that keeps every engagement organised —
            from first conversation through to delivery and refinement.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.n}
                data-testid={`process-step-${i}`}
                className="card-hover relative rounded-2xl border border-[rgba(198,162,99,0.14)] bg-[#0e0c09] p-7"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center border border-[rgba(198,162,99,0.28)] bg-[rgba(198,162,99,0.04)]">
                    <Icon size={20} className="text-[rgb(var(--gold-soft))]" />
                  </div>
                  <span className="sec-num text-sm">{s.n}</span>
                </div>
                <h3 className="mt-6 font-serif-display text-[26px] text-[rgb(var(--bone))]">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[rgb(var(--bone-dim))]">
                  {s.desc}
                </p>
              </article>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#contact"
            data-testid="process-cta"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm font-medium btn-gold"
          >
            Start Your Project
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
